import { Nullable } from "@core/domain/types/nullable.type";
import { injectable } from "inversify";
import { PaymentMethodTypeEnum } from "@entity/domain/models/payment-method.model";
import { PaymentMethodTypeEnumDto } from "@entity/data/dto/payment-method-type.dto";

@injectable()
export class PaymentMethodEnumMapper {
    map(
        paymentMethodEnumDto: PaymentMethodTypeEnumDto,
    ): Nullable<PaymentMethodTypeEnum> {
        switch (paymentMethodEnumDto) {
            case PaymentMethodTypeEnumDto.transfer:
                return PaymentMethodTypeEnum.transfer;
            case PaymentMethodTypeEnumDto.cash:
                return PaymentMethodTypeEnum.cash;
            case PaymentMethodTypeEnumDto.card:
                return PaymentMethodTypeEnum.card;
            case PaymentMethodTypeEnumDto.paypal:
                return PaymentMethodTypeEnum.paypal;
            case PaymentMethodTypeEnumDto.other:
                return PaymentMethodTypeEnum.other;
            default:
                return null;
        }
    }

    mapToDto(
        paymentMethodEnum: PaymentMethodTypeEnum,
    ): PaymentMethodTypeEnumDto {
        switch (paymentMethodEnum) {
            case PaymentMethodTypeEnum.transfer:
                return PaymentMethodTypeEnumDto.transfer;
            case PaymentMethodTypeEnum.cash:
                return PaymentMethodTypeEnumDto.cash;
            case PaymentMethodTypeEnum.card:
                return PaymentMethodTypeEnumDto.card;
            case PaymentMethodTypeEnum.paypal:
                return PaymentMethodTypeEnumDto.paypal;
            case PaymentMethodTypeEnum.other:
                return PaymentMethodTypeEnumDto.other;
        }
    }
}